const chopArrayHead = (array, range) => {
  const result = array.slice(...range);
  return result;
};

export default chopArrayHead;
